import zhCN from '../locales/zh_CN';

const translationMappings = locale => {
  const defaultLocale = 'zh_CN';
  const translations = {
    zh_CN: zhCN,
  };

  if (translations[locale]) {
    return translations[locale];
  }
  return translations[defaultLocale];
};

const getTranslationsByLocale = locale => translationMappings(locale);

export default getTranslationsByLocale;
